import styled from 'styled-components';
import { ifProp } from 'styled-tools';

const Page = styled.div`
  min-height: calc(100vh - 95px);
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(16, 1fr);
  grid-template-columns: ${({ columns }) => `repeat(${columns || '16'}, 1fr);`};
  padding: 8px 8px 60px 8px;
  grid-auto-rows: min-content;
  overflow: ${({ overflow }) => overflow || 'initial'};
  max-width: ${({ maxWidth }) => maxWidth || 'none'};
  margin: ${({ margin }) => margin || 0};

  ${ifProp('alignItems', ({ alignItems }) => `align-items: ${alignItems}`)};

  ${ifProp('outline', () => `outline: solid green 1px;`)};

  > * {
    grid-column: 1 / -1;
  }
`;

export default Page;
